import React, { Fragment, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CommonButton from '../../component/button/Button';
import AuthBg from '../../component/auth/AuthBg';
import Heading from '../../component/Heading/Heading';
import { NewPasswordData } from '../../content/content';
import InputComponent from '../../component/input/Input';
import { useNavigate, useParams } from 'react-router';
import { forgotPassword } from '../../services/authenticationService';
import Toast from '../../component/toastify/Index';
import logo from "../../assets/icons/logo.svg"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { checkTokenAndNavigate } from '../../utils/js/expireInvitation';
import "../../styles/pages/auth/signUp.scss"
import "../../styles/pages/auth/newPassword.scss"
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const NewPassword = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { token } = useParams();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        number: false,
        specialChar: false,
    });
    const [isPassword, setIsPassword] = useState(false);

    useEffect(() => {
        checkTokenAndNavigate(token, navigate);
    }, [token])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'password') {
            setPasswordCriteria({
                length: value.length >= 8,
                uppercase: /[A-Z]/.test(value),
                number: /[0-9]/.test(value),
                noSpaces: !/\s/.test(value),
            });
            setIsPassword(true);
        }
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleToggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prev) => !prev);
    };

    const validate = () => {
        let valid = true;
        const newErrors = {};
        NewPasswordData.forEach((item) => {
            if (!formData[item.name]?.trim() && item.name != "password") {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            } else if (item.name === 'confirm_password') {
                if (formData['confirm_password'] !== formData['password']) {
                    newErrors[item.name] = `${t('common_is_valid_password_match')}`;
                    valid = false;
                }
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsPassword(true)

        try {
            if (!validate()) return;

            const response = await forgotPassword({ password: formData.password }, token);
            if (response?.isSuccess) {
                navigate("/signIn");
                Toast(response?.message, "success");
            }
        } catch (error) {
            Toast(error?.message, "error");
        }
    };

    return (
        <div className="auth">
            <div className="signup-container new-password">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className="min-vh-100">
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />                        </div>

                        <div className="signup-data">
                            <form onSubmit={handleSubmit}>
                                <div className="input-container">
                                    <Heading text={t("common_text_set_new_password")} />
                                    <p className="new-password-text">
                                        {t("common_text_secure_pwd")}
                                    </p>
                                    {NewPasswordData.map((item, index) => (
                                        <div key={index} className="pt-2">
                                            <Fragment>
                                                <InputComponent
                                                    type={item.name === 'password' ? (showPassword ? 'text' : 'password') : (showConfirmPassword ? 'text' : 'password')}
                                                    placeholder={t(item.placeholderTranslationKey)}
                                                    label={t(item.translationKey)}
                                                    className="input-field"
                                                    name={item.name}
                                                    value={formData[item.name] || ''}
                                                    onChange={handleChange}
                                                    required
                                                     isAuth
                                                    error={
                                                        !isPassword ? false :
                                                            item.name === "password" ?
                                                                !passwordCriteria.length || !passwordCriteria.uppercase || !passwordCriteria.number || !passwordCriteria.noSpaces :
                                                                item.name === "confirm_password" ? !!errors[item.name] : false
                                                    }
                                                    helperText={errors[item.name]}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={item.name === 'password' ? handleTogglePasswordVisibility : handleToggleConfirmPasswordVisibility}
                                                                    edge="end"
                                                                >
                                                                    {item.name === 'password' ? (showPassword ? <VisibilityOff className="text-blue" /> : <Visibility className="text-blue" />) :
                                                                        (showConfirmPassword ? <VisibilityOff className="text-blue" /> : <Visibility className="text-blue" />)
                                                                    }
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                {item.name === "password" && <Typography className='password-validation' sx={{ display: !isPassword && "none", paddingTop: "10px" }}>
                                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.length ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                        {passwordCriteria.length ? (
                                                            <CheckIcon style={{ color: 'green', marginRight: '8px' }} />
                                                        ) : (
                                                            <CloseIcon style={{ color: '#d32f2f', marginRight: '8px' }} />
                                                        )}
                                                        {t('common_text_8_characters')}
                                                    </p>
                                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.uppercase ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                        {passwordCriteria.uppercase ? (
                                                            <CheckIcon style={{ color: 'green', marginRight: '8px' }} />
                                                        ) : (
                                                            <CloseIcon style={{ color: '#d32f2f', marginRight: '8px' }} />
                                                        )}
                                                        {t('common_text_1_uppercase')}
                                                    </p>
                                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.number ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                        {passwordCriteria.number ? (
                                                            <CheckIcon style={{ color: 'green', marginRight: '8px' }} />
                                                        ) : (
                                                            <CloseIcon style={{ color: '#d32f2f', marginRight: '8px' }} />
                                                        )}
                                                        {t('common_text_1_number')}
                                                    </p>
                                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.noSpaces ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                        {passwordCriteria.noSpaces ? (
                                                            <CheckIcon style={{ color: 'green', marginRight: '8px' }} />
                                                        ) : (
                                                            <CloseIcon style={{ color: '#d32f2f', marginRight: '8px' }} />
                                                        )}
                                                        {t('common_text_no_space')}
                                                    </p>
                                                </Typography>
                                                }
                                            </Fragment>
                                        </div>
                                    ))}
                                </div>
                                <div className="checkbox-container pt-4">
                                    <FormControlLabel
                                        label={t("common_text_aggree_t&c")}
                                        control={
                                            <Checkbox
                                                variant="plain"
                                                sx={{
                                                    "& .MuiSvgIcon-root": {
                                                        fill: "#F5D01C",
                                                        fontSize: 30,
                                                    },
                                                }}
                                            />
                                        }
                                    />
                                </div>

                                <div className="signup-button">
                                    <CommonButton
                                        type="submit"
                                        text={t("common_text_submit")}
                                        className="submit-button w-100"
                                    />
                                </div>
                            </form>
                        </div>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default NewPassword;
